import type { ClientPortfolioDetailToolResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { ClientPortfolioToolIdentificationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { ToolType } from "./investmentToolTypes";

export const makeRowKey = (
	tool: ClientPortfolioDetailToolResponseDTO,
): string => {
	if (tool.commodities && tool.commodities.length > 0) {
		return `commodity-${tool.id}`;
	}
	if (
		tool.cryptocurrencyInstructions &&
		tool.cryptocurrencyInstructions.length > 0
	) {
		const item = tool.cryptocurrencyInstructions[0];
		return `crypto-${tool.id}-${item.id}`;
	}
	if (tool.investments && tool.investments.length > 0) {
		return `investment-${tool.id}`;
	}
	return `other-${tool.id}`;
};

export const getToolType = (
	tool: ClientPortfolioDetailToolResponseDTO,
): ToolType => {
	if (tool.commodities && tool.commodities.length > 0) {
		return ToolType.Commodity;
	}
	if (
		tool.cryptocurrencyInstructions &&
		tool.cryptocurrencyInstructions.length > 0
	) {
		return ToolType.Crypto;
	}
	if (tool.investments && tool.investments.length > 0) {
		return ToolType.Investment;
	}
	if (tool.bonds && tool.bonds.length > 0) {
		return ToolType.Bond;
	}
	if (
		tool.identificationType ===
		ClientPortfolioToolIdentificationTypeEnum.BankProduct
	) {
		return ToolType.BankProduct;
	}
	return ToolType.Default;
};
